import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

function ProtectedRoute ({children, allowedRoles = []}) {

    const { auth, logout } = useContext(AuthContext);

    if (auth.access_token == null) {
        return <Navigate to="/login" />
    }

    // Redirect for Un-Authorized Trades
    if (allowedRoles.length && auth.user?.role && !allowedRoles.includes(auth.user.role)) {
        logout();
        return <Navigate to="/login" replace />;
    }

    return children
}

export default ProtectedRoute;
